module.exports = __webpack_public_path__ + "static/media/main2.131b479e.jpg";